<template>
    <em-z-tree ref="deptUserTree" :nodeAppender="appendIcon2UserNodes"
               :treeNodes="deptUserTreeNodes" :chkboxType="chkboxType"
               :checked-ids="selectedPrefixId"
               enable-auto-expand-checked
               checkEnable>
    </em-z-tree>
</template>
<script>
// Author YuJiaBei
// Date 2020-10-8 14:25:08

import EmZTree from "@/components/em/EmZTree";
import EmCommonApi from "@/mixin/em/common/api";

export default {
    name: "emDeptUserTree",
    mixins: [EmCommonApi],
    components: {EmZTree},
    props: {
        deptId: {
            type: [String, Number],
            default: ""
        },
        deptNodeCode: {
            type: String,
            default: ""
        },
        customApi: {
            type: String,
            default: "deptUserTree"
        },
        selectedId: {
            type: [String, Number],
            default: ""
        },
    },
    data() {
        return {
            deptUserTreeNodes: [],
            userPrefix: "user_",
            deptPrefix: "dept_",
            chkboxType: {"Y": "s", "N": "s"}, //父节点可以连带子节点，子节点不连带父节点
            selectedPrefixId: ""
        }
    },
    methods: {
        getDeptUserTreeNodes(deptId, deptNodeCode) {
            let entityApi = this.$_emApiMixin_entityBaseApi("emAclUser");
            let url = this.customApi === "deptUserTree" ? `${entityApi}/${this.customApi}` : this.customApi
            this.$_emApiMixin_post(url, {
                emAclDeptIdFilter: deptId,
                emAclDeptNodeCodeFilter: deptNodeCode
            }).then((response) => {
                // console.log(response.data)
                this.deptUserTreeNodes = response.data
                this.initSelectedId();
            })
        },
        getUserIds() {
            let userNodes = this.$refs['deptUserTree'].getCheckedNodes()
            var v = "";
            for (var i = 0; i < userNodes.length; i++) {
                if (userNodes[i].id.startsWith(this.userPrefix)) {
                    v += "," + userNodes[i].userId;
                }
            }
            return v.length > 0 ? v.substring(1) : v;
        },
        appendIcon2UserNodes(deptNodeCode) {
            let userPrefix = "user_"
            let deptPrefix = "dept_"
            if (deptNodeCode.id.startsWith(userPrefix)) {
                return Object.assign({iconSkin: "iconUser"}, deptNodeCode)
            } else if (deptNodeCode.id.startsWith(deptPrefix)) {
                if (!deptNodeCode.isParent)
                    return Object.assign({iconSkin: "iconBuilding"}, deptNodeCode)
                else
                    return Object.assign({iconSkin: "pIconBuilding"}, deptNodeCode)
            }
        },
        initSelectedId() {
            let tempList = this.selectedId.split(",");
            let tempStr = "";
            for (let item of tempList) {
                tempStr += "," + this.userPrefix + item;
            }
            this.selectedPrefixId = tempStr.substring(1);
        }
    },
    mounted() {
        this.getDeptUserTreeNodes(this.deptId, this.deptNodeCode)
    }
};
</script>